export default class CreateJourneyTemplateRequest  {
	name = '';
    distanceOneWay = 0;
    travelTimeOneWay = 0;
}